'use client';

import { Button } from '@common/components';
import { usePathname } from 'next/navigation';
import { type PropsWithChildren, useEffect, useState } from 'react';

import { MEMBER_JOIN_STATUS } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { ROUTES, STORAGE_KEY } from '@/constants';
import { useAuthStore } from '@/stores/AuthStore';

const RecommendPolicyTemplate = ({ children }: PropsWithChildren) => {
  const pathname = usePathname();
  const [isOpened, setIsOpened] = useState(false);
  const isEmptyFilter = useAuthStore(
    (state) =>
      state.myInfo?.memberJoinStatus === MEMBER_JOIN_STATUS.EMPTY_FILTER,
  );

  useEffect(() => {
    const hasIgnored = sessionStorage.getItem(
      STORAGE_KEY.POLICY_FILTER_LANDING,
    );

    if (hasIgnored || !isEmptyFilter) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- sessionStorage 기반 마운트 init (SSR 하이드레이션 게이트)
      setIsOpened(false);

      return;
    }

    setIsOpened(true);
  }, [isEmptyFilter]);

  return (
    <>
      {children}
      <ResponsiveDialog
        opened={isOpened}
        onClose={() => setIsOpened(false)}
        drawerType="bottom"
      >
        <div className="pb-16">
          <h3 className="mb-8 font-700 text-Gray-900 typo-body2">
            나에게 맞는 정책을 받아보세요!
          </h3>
          <p className="font-400 text-Gray-700 typo-body4">
            관심사를 알려주시면, 딱 맞는 정책을 추천해 드릴게요.
          </p>
          <footer className="mt-28 flex gap-8">
            <Button
              className="min-w-120"
              theme="primary-line"
              onClick={() => {
                setIsOpened(false);
                sessionStorage.setItem(
                  STORAGE_KEY.POLICY_FILTER_LANDING,
                  'ignore',
                );
              }}
            >
              나중에
            </Button>
            <Button asChild className="flex-1">
              <CustomLink
                href={ROUTES.POLICY_FILTER.pathname({
                  situation: 'join',
                })}
                onClick={() =>
                  sessionStorage.setItem(
                    STORAGE_KEY.POLICY_FILTER_LANDING_FROM,
                    pathname ?? '',
                  )
                }
              >
                네, 받을래요
              </CustomLink>
            </Button>
          </footer>
        </div>
      </ResponsiveDialog>
    </>
  );
};

export default RecommendPolicyTemplate;
